const Products = () => {
    return (
        <>
            <h1 className="display-3 mb-4">Products</h1>
            <div>
            </div>
        </>
    )
}
export default Products